import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

const EnrollValidate = observer(class EnrollValidate extends React.Component {
  constructor() {
    super();
    this.handleRetry = this.handleRetry.bind(this);
    this.complete = this.complete.bind(this);
  }

  componentWillMount() {
    this.props.store.SmarterIDStore.validateEnrollment(this.complete);
  }

  handleRetry() {
    const { validationError } = this.props.store.SmarterIDStore;
    let step = 1;

    if(validationError === '1213' || validationError === '1210') {
      // confirm.io validation failed and user needs to upload new id photos
      this.props.parent.setState({
        acceptedPhotos: [],
        headshot: null,
        headshotUploaded: false,
        idBack: null,
        idBackUploaded: false,
        idFront: null,
        idFrontUploaded: false,
        pendingPhotos: [],
        uploadedPhotos: []
      })
    } else if(validationError === '1214') {
      // Facial match failed and user needs to upload new headshot
      step = 3;

      this.props.parent.setState({
        acceptedPhotos: ['idFront', 'idBack'],
        headshot: null,
        headshotUploaded: false,
        pendingPhotos: [],
        uploadedPhotos: ['idFrontUploaded', 'idBackUploaded']
      })
    }

    this.props.setPCStep(null, step);

    this.props.parent.setState({
      validating: false,
      complete: false
    });
  }

  complete() {
    this.props.setStep(null, 5);
    this.props.setDisplayStep(3);
  }

  render() {
    const { translation } = this.props;
    const { validationError, validationFailed} = this.props.store.SmarterIDStore;

    if(!validationFailed) {
      return(
        <div className={`panel panel--brief ${this.props.isActive}`}>
          <h1 className="panel__title">{translation.heading}</h1>
          <p>{translation.body}</p>
          <span className="loader--alt"><span className="meta">Loading…</span></span>
        </div>
      );
    } else if(validationFailed && (validationError === '1213' || validationError === '1210' || validationError === '1214')) {
      return (
        <div className={`panel panel--brief ${this.props.isActive}`}>
          <h1 className="panel__title">{translation[validationError].heading}</h1>
          <p>{translation[validationError].body}</p>
          <button
            className="btn"
            onClick={this.handleRetry}
          >
            {translation.retake}
          </button>
        </div>
      )
    } else if(validationFailed) {
      return (
        <div className={`panel panel--brief ${this.props.isActive}`}>
          <h1 className="panel__title">{translation.error.heading}</h1>
          <p>{translation.error.body}</p>
          <button
            className="btn"
            onClick={this.handleRetry}
          >
            {translation.retake}
          </button>
        </div>
      )
    }

    return null;
  }
})

export default translate('EnrollValidate')(EnrollValidate);


// WEBPACK FOOTER //
// ./src/app/components/Enroll/EnrollValidate.js